/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Featurestitle1Inputs */

const id_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fitur`)
};

const ms_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ciri-ciri`)
};

const da_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner`)
};

const de_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen`)
};

const en_us2_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Features`)
};

const es_es2_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

const es_mx2_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones`)
};

const fil_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Tampok`)
};

const fr_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctionnalités`)
};

const it_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità`)
};

const hu_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkciók`)
};

const nl_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functies`)
};

const no_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funksjoner`)
};

const pl_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje`)
};

const pt_br2_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Características`)
};

const pt_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funcionalidades`)
};

const ro_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caracteristici`)
};

const fi_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ominaisuudet`)
};

const sv_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktioner`)
};

const vi_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tính năng`)
};

const tr_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özellikler`)
};

const cs_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkce`)
};

const bg_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функции`)
};

const ru_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Возможности`)
};

const uk_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можливості`)
};

const ar_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الميزات`)
};

const hi_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विशेषताएँ`)
};

const th_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฟีเจอร์`)
};

const ja_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`機能`)
};

const zh_cn2_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能特点`)
};

const zh_hant1_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`功能特點`)
};

const ko_privacy_featurestitle1 = /** @type {(inputs: Privacy_Featurestitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기능`)
};

/**
* | output |
* | --- |
* | "Features" |
*
* @param {Privacy_Featurestitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const privacy_featurestitle1 = /** @type {((inputs?: Privacy_Featurestitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Featurestitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_privacy_featurestitle1(inputs)
	if (locale === "ms") return ms_privacy_featurestitle1(inputs)
	if (locale === "da") return da_privacy_featurestitle1(inputs)
	if (locale === "de") return de_privacy_featurestitle1(inputs)
	if (locale === "en-US") return en_us2_privacy_featurestitle1(inputs)
	if (locale === "es-ES") return es_es2_privacy_featurestitle1(inputs)
	if (locale === "es-MX") return es_mx2_privacy_featurestitle1(inputs)
	if (locale === "fil") return fil_privacy_featurestitle1(inputs)
	if (locale === "fr") return fr_privacy_featurestitle1(inputs)
	if (locale === "it") return it_privacy_featurestitle1(inputs)
	if (locale === "hu") return hu_privacy_featurestitle1(inputs)
	if (locale === "nl") return nl_privacy_featurestitle1(inputs)
	if (locale === "no") return no_privacy_featurestitle1(inputs)
	if (locale === "pl") return pl_privacy_featurestitle1(inputs)
	if (locale === "pt-BR") return pt_br2_privacy_featurestitle1(inputs)
	if (locale === "pt") return pt_privacy_featurestitle1(inputs)
	if (locale === "ro") return ro_privacy_featurestitle1(inputs)
	if (locale === "fi") return fi_privacy_featurestitle1(inputs)
	if (locale === "sv") return sv_privacy_featurestitle1(inputs)
	if (locale === "vi") return vi_privacy_featurestitle1(inputs)
	if (locale === "tr") return tr_privacy_featurestitle1(inputs)
	if (locale === "cs") return cs_privacy_featurestitle1(inputs)
	if (locale === "bg") return bg_privacy_featurestitle1(inputs)
	if (locale === "ru") return ru_privacy_featurestitle1(inputs)
	if (locale === "uk") return uk_privacy_featurestitle1(inputs)
	if (locale === "ar") return ar_privacy_featurestitle1(inputs)
	if (locale === "hi") return hi_privacy_featurestitle1(inputs)
	if (locale === "th") return th_privacy_featurestitle1(inputs)
	if (locale === "ja") return ja_privacy_featurestitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_privacy_featurestitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_privacy_featurestitle1(inputs)
	return ko_privacy_featurestitle1(inputs)
});
export { privacy_featurestitle1 as "privacy.featuresTitle" }